import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    padding: '1em 1em 0.75em',
    textDecoration: 'none',
    width: 'calc(25% - 10px)',
    color: theme.palette.text.primary,
    display: 'inline-flex',
    fontSize: '0.85em',
    margin: '0 10px 10px 0',
    flexDirection: 'column',
    cursor: 'pointer',
    position: 'relative',
    '& p': {
      overflow: 'hidden',
      display: 'inline-block',
      margin: 0,
      color: '#666',
      padding: '0 1.5em 0 2.5em',
      height: '3em',
    },
    '& h4': {
      margin: '0',
      display: 'flex',
      alignItems: 'flex-start',
      '& span': {
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        paddingRight: '2em',
        textTransform: 'uppercase',
        color: '#666',
      },
      '& svg': {
        color: '#aaa',
        marginRight: '0.25em',
      },
    },
  },
  action: {
    marginBottom: 20,
    '& svg': {
      marginRight: 5,
    },
    '& button': {
      border: `1px solid ${theme.palette.primary.light}`,
      paddingRight: 15,
    }
  },
  '@media (max-width: 850px)': {
    paper: {
      width: 'calc(33.3333% - 10px)',
    }
  },
  '@media (max-width: 600px)': {
    paper: {
      width: 'calc(50% - 10px)',
    }
  },
  '@media (max-width: 450px)': {
    paper: {
      width: 'calc(100% - 10px)',
    }
  }
}));